export const LIVESTREAM_RANDOM_PARTICIPANT_MESSAGE_TYPE = "fanrank:randomParticipant";

export function generateLivestreamRandomParticipantDrawId(): string {
  if (typeof crypto?.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export type LivestreamRandomParticipantDraw = {
  id: string;
  winner: string;
  names: string[];
};

export function parseLivestreamRandomParticipantDraw({
  payload,
}: {
  payload: Record<string, boolean | number | string | Date>;
}): LivestreamRandomParticipantDraw | null {
  const id = payload.id;
  const winner = payload.winner;
  const namesJson = payload.names;

  if (typeof id !== "string" || typeof winner !== "string" || typeof namesJson !== "string") {
    return null;
  }

  try {
    const parsed = JSON.parse(namesJson) as unknown;
    if (!Array.isArray(parsed) || !parsed.every((name) => typeof name === "string")) {
      return null;
    }
    if (!parsed.includes(winner)) return null;

    return {
      id,
      winner,
      names: parsed,
    };
  } catch {
    return null;
  }
}

export function buildLivestreamRandomParticipantPayload({
  draw,
}: {
  draw: LivestreamRandomParticipantDraw;
}): Record<string, string> {
  return {
    id: draw.id,
    winner: draw.winner,
    names: JSON.stringify(draw.names),
  };
}
